import { colors } from 'ui/theme/colors';

export const journeyRadioIllustrationColors = {
  /** #F5F4F4 */
  backgroundColor: colors.grey5,
  /** #0E9976 */
  lineColor: colors.green100,
  /** #CAF3E7 */
  fillColor: colors.green20,
  /** #59C1A7 */
  fillSecondaryColor: colors.green50,
};
